import React from "react";
const TermsAndConditions = ({ lastUpdated }) => {
  return (
    <div className="terms-page">
      <h1>Terms & Conditions</h1>
      <span className="last-updated">Last Updated: {lastUpdated}</span>

      <div className="terms-content-wrapper">
        <section>
          <p>
            <strong>Effective Date:</strong> 01/07/2024
          </p>
          <p>
            Welcome to the website of Lighthouse Realty Solutions Private
            Limited (“we”). By accessing our website and using our services, you
            agree to comply with and be bound by these Terms and Conditions.
          </p>
        </section>

        <section>
          <h2>1. Introduction</h2>
          <p>
            These Terms and Conditions govern your use of our website and
            services. Please read them carefully before proceeding.
          </p>
        </section>

        <section>
          <h2>2. Acceptance of Terms</h2>
          <p>
            By using our website, you acknowledge that you have read,
            understood, and agree to be bound by these terms. If you do not
            agree with these terms, please do not use our website.
          </p>
        </section>

        <section>
          <h2>3. Use of Information</h2>
          <p>
            <strong>Data Collection:</strong> We collect information when you
            visit our site, fill out forms, or interact with our services. This
            includes personal and non-personal identification information.
          </p>
          <p>
            <strong>Usage of Data:</strong>
          </p>
          <ul>
            <li>To process your inquiries and provide customer support.</li>
            <li>
              To improve our website and offerings based on user feedback.
            </li>
            <li>
              To send promotional materials and marketing communications related
              to our services.
            </li>
          </ul>
        </section>

        <section>
          <h2>4. Marketing Communications</h2>
          <p>
            <strong>Opt-In Consent:</strong> By providing your contact
            information, you consent to receive marketing communications from
            us, including emails, newsletters, and promotional offers.
          </p>
        </section>

        <section>
          <h2>5. Data Sharing and Transfer</h2>
          <p>
            We do not sell, trade, or rent your personal information to third
            parties. We may share data with trusted partners who assist in our
            operations, provided they maintain strict confidentiality.
          </p>
        </section>

        <section>
          <h2>6. Cookies and Tracking Technologies</h2>
          <p>
            Our website uses cookies to enhance user experience. You can choose
            to accept or decline cookies through your browser settings.
          </p>
        </section>

        <section>
          <h2>7. Third-Party Links</h2>
          <p>
            We are not responsible for the content or privacy practices of
            third-party websites linked on our site. Use them at your own risk.
          </p>
        </section>

        <section>
          <h2>8. Changes to Terms and Conditions</h2>
          <p>
            We may update these terms periodically. It is your responsibility to
            review this page regularly for any changes.
          </p>
        </section>

        <section>
          <h2>9. Governing Law</h2>
          <p>
            These terms are governed by the laws of India. Any disputes shall be
            subject to the exclusive jurisdiction of the courts of India.
          </p>
        </section>

        <section className="grievance-card">
          <h2>10. Contact Information</h2>
          <p>For any questions or concerns, please contact us at:</p>
          <p>
            <strong>MMR BIGHOUSE ESTATES PRIVATE LIMITED</strong>
            <br />
            <strong>Phone:</strong>{" "}
            <span className="email-highlight">8879272149</span>
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;
